import React, { useState } from "react";
import { useFormik } from "formik";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

import {
  FiArrowLeft,
  FiLock,
  FiPhone,
} from "react-icons/fi";
import styles from "./ForgotPassword.module.css";
import api from "../../services/axiosConfig";
import { OTP_SEND_FORGOT } from "../../constant-value";
import { validationForgotSchema } from "../../constant-value/schema";



const ForgotPassword = () => {
  const navigate = useNavigate();

  const [body, setBody] = useState({
    phoneNumber: "",
    newPassword: null,
    confirmPassword: null,
    otpCode: null,
  });

  const message = (text, type) => {
    if (type === "warn") {
      toast.warning(text, {
        autoClose: 1500,
      });

      return;
    }

    toast.success(text, {
      autoClose: 1500,
    });
  };

  const {
    values,
    errors,
    touched,
    isSubmitting,
    handleBlur,
    handleSubmit,
  } = useFormik({
    enableReinitialize: true,
    initialValues: body,
    validationSchema: validationForgotSchema,

    onSubmit: (values) => {
      api
        .post(`/${OTP_SEND_FORGOT}`, values)
        .then((res) => {
          const data = res.data;

          if (data.isSuccess) {
            message(data.message, "success");

            navigate(
              `/forgot-otp/${values.phoneNumber}`
            );

            return;
          }

          message(data.message, "warn");
        })
        .catch((error) => {
          console.log("FORGOT PASSWORD ERROR:", error);

          message(
            error.response?.data?.message ||
              "چند دقیقه دیگر تلاش نمایید، خطایی رخ داده است",
            "warn"
          );
        });
    },
  });

  const changeHandle = (event) => {
    const { id, value } = event.target;

    setBody((prev) => ({
      ...prev,
      [id]: value,
    }));
  };

  return (
    <div className={styles.page} dir="rtl">
      <div className={styles.container}>

        {/* Header */}

        <div className={styles.header}>
          <div className={styles.iconBox}>
            <FiLock />
          </div>

          <h1>بازیابی کلمه عبور</h1>

          <p>
            شماره همراه خود را وارد کنید تا کد تأیید
            برای شما ارسال شود.
          </p>
        </div>

        {/* Form */}

        <form
          className={styles.form}
          onSubmit={handleSubmit}
        >
          <div className={styles.field}>

            <label htmlFor="phoneNumber">
              شماره همراه
            </label>

            <div className={styles.inputWrapper}>
              <FiPhone />

              <input
                id="phoneNumber"
                type="tel"
                inputMode="numeric"
                autoComplete="tel"
                placeholder="09123456789"
                value={values.phoneNumber}
                onChange={changeHandle}
                onBlur={handleBlur}
                className={
                  errors.phoneNumber &&
                  touched.phoneNumber
                    ? styles.inputError
                    : ""
                }
              />
            </div>

            {errors.phoneNumber &&
              touched.phoneNumber && (
                <span className={styles.error}>
                  {errors.phoneNumber}
                </span>
              )}
          </div>

          <button
            type="submit"
            disabled={isSubmitting}
            className={styles.submitButton}
          >
            {isSubmitting ? (
              <>
                <span className={styles.spinner} />
                در حال ارسال...
              </>
            ) : (
              <>
                ارسال کد تأیید
                <FiArrowLeft />
              </>
            )}
          </button>
        </form>

        {/* Back to Login */}

        <div className={styles.loginLink}>
          <span>رمز عبورتان را به یاد آوردید؟</span>

          <Link to="/login">
            ورود به سامانه
          </Link>
        </div>

      </div>
    </div>
  );
};

export default ForgotPassword;